module.exports = __webpack_public_path__ + "static/img/weixincode.9cf0fc68.png";